interface Props {
  className?: string;
}

export function GrassBlades({ className = '' }: Props) {
  return (
    <svg viewBox="0 0 200 40" className={className} fill="none" aria-hidden="true">
      {[10, 30, 50, 70, 90, 110, 130, 150, 170, 190].map((x, i) => (
        <path
          key={i}
          d={`M${x} 40 Q${x + (i % 2 ? 3 : -3)} 20 ${x + (i % 2 ? -1 : 1)} 0`}
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      ))}
    </svg>
  );
}
